if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"shell","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return 660 != chunkId},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}